import React from "react";

import styled from "@emotion/styled";

const CalendarIcon = ({ color = "#E1E1E1", hoverColor = color }) => {
    const SVG = styled.svg`
        fill: ${color};

        &:hover {
            fill: ${hoverColor};
        }
    `;
    return (
        <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M100.286,64a.828.828,0,0,1,.857.8v1.333h5.714V64.8a.859.859,0,0,1,1.714,0v1.333h1.143A2.216,2.216,0,0,1,112,68.267v9.6A2.216,2.216,0,0,1,109.714,80H98.286A2.216,2.216,0,0,1,96,77.867v-9.6a2.216,2.216,0,0,1,2.286-2.133h1.143V64.8A.828.828,0,0,1,100.286,64Zm0,3.733h-2a.555.555,0,0,0-.571.533v1.6h12.571v-1.6a.555.555,0,0,0-.571-.533Zm-2.571,3.733v6.4a.555.555,0,0,0,.571.533h11.429a.555.555,0,0,0,.571-.533v-6.4Z"
                transform="translate(-96 -64)"
            />
        </SVG>
    );
};

export default CalendarIcon;
